<template>
  <div class="rightModal">
    <Input
      label="global.name"
      placeholder="global.name"
      id="name"
      v-model="form.name"
      :state="validateState('name')"
    />

    <b-form-group :label="$t('servers.datacenter')">
      <multiselect
        id="multiselectdatacenter"
        v-model="form.datacenter"
        :options="datacenterList"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('forms.cloudsNodes.enterDatacenterForSearch')"
        :loading="loading"
        :custom-label="customListLabel"
        @search-change="getDatacenterList"
        :limit="3"
        :show-no-results="false"
        :state="validateState('datacenter')"
      />
    </b-form-group>

    <b-form-group :label="$t('global.type')" :state="validateState('type')">
      <multiselect
        v-model="form.type"
        :options="typeList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('global.type')"
        :show-no-results="false"
      />
    </b-form-group>

    <Input
      label="global.ipAddress"
      id="ip"
      placeholder="examples.ip"
      v-model="form.ip"
      :state="validateState('ip')"
    />

    <Input
      label="servers.username"
      placeholder="servers.enterUsername"
      id="username"
      v-model="form.username"
      :state="validateState('username')"
    />

    <Input
      label="servers.password"
      placeholder="servers.enterPassword"
      id="password"
      v-model="form.password"
      type="password"
      :state="validateState('password')"
    />
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CreateStorageMembers',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
  },
  data() {
    return {
      form: {
        name: '',
        datacenter: '',
        type: '',
        ip: '',
        username: '',
        password: '',
      },
      datacenterList: [],
      typeList: [
        { id: 'sn10-ff', name: 'SN10-FF' },
        { id: 'sn22-ff', name: 'SN22-FF' },
        { id: 'sn44-ff', name: 'SN44-FF' },
        { id: 'other', name: 'Other' },
      ],
      loading: false,
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      datacenter: {
        required,
      },
      type: {
        required,
      },
      ip: {
        required,
      },
      username: {
        required,
      },
      password: {
        required,
      },
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
  created() {
    this.getDatacenterList()
  },
  methods: {
    getDatacenterList(search) {
      this.loading = true

      if (search != '') {
        this.datacenterList = []
      }

      this.getList(search)
        .then((res) => {
          this.setList(res)
          this.loading = false
        })
        .catch(() => {
          this.datacenterList = []
        })
    },
    getList(search) {
      return new Promise((resolve, reject) => {
        let query = `iaas/datacenters?orderBy=position|ASC`

        if (search && search != '') {
          query += `&name=${search}`
        }

        ApiService.get(query)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    setList(res) {
      this.datacenterList = res.data
    },
    customListLabel({ name }) {
      return `${name}`
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.name,
        device_type: this.form.type.id,
        ip_addr: this.form.ip,
        username: this.form.username,
        password: this.form.password,
        datacenter_ref: this.form.datacenter.id,
        storage_pool_ref: this.$route.params.id,
        controller: 'local',
        currency_code: 'USD',
        hourly_price: 0,
        network_uplink_type: 'local',
        storage_type: 'plusclouds-sn',
        total_hdd: 1000,
      }

      ApiService.post(`storage/members`, params)
        .then(() => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
}
</script>
